<div class="container content-layout right-sidebar-fullheight-basic-inner-scroll">
  <!-- Main -->
  <div class="main">
    <div class="list-wrapper">
      <!-- Header -->
      <div class="header">
        <!-- Title -->
        <div class="title">
          <h1>Automations</h1>

          <div class="automations-count">
            <ng-container *ngIf="automationCount > 0">
              {{ automationCount }}
            </ng-container>
            {{
              automationCount
                | i18nPlural
                  : {
                      '=0': 'No automations',
                      '=1': 'automation',
                      other: 'automations'
                    }
            }}
          </div>
        </div>

        <!-- Main actions -->
        <div class="main-actions">
          <!-- Add automation button -->
          <button class="add-automation" mat-flat-button [color]="'primary'" (click)="addAutomation()">
            <mat-icon [svgIcon]="'add'"></mat-icon>
            New Automation
          </button>
        </div>
      </div>

      <mat-progress-bar mode="indeterminate" [class.hidden]="!isLoading"></mat-progress-bar>

      <!-- Automations list -->
      <div class="automations-list">
        <div class="table-wrapper">
          <div class="inline-table-wrapper">
            <ng-container *ngIf="automations$ | async as automations">
              <ng-container *ngIf="automations?.length > 0; else noAutomations">
                <!-- Table -->
                <table mat-table [dataSource]="automations">
                  <!-- Name -->
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let automationSetting" (click)="editAutomation(automationSetting)">
                      <div class="name-content">
                        <span class="name">{{ automationSetting?.name }}</span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Status -->
                  <ng-container matColumnDef="options">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let automationSetting">
                      <div class="flex items-center">
                        <span class="mr-2">Off</span>
                        <mat-slide-toggle
                          color="primary"
                          [checked]="automationSetting?.is_active"
                          (change)="automationToggle($event, automationSetting)"
                        >
                          On
                        </mat-slide-toggle>
                        <button class="ml-6" mat-icon-button type="button" [matMenuTriggerFor]="automationOptions">
                          <mat-icon class="icon-size-20" [svgIcon]="'more_vert'"></mat-icon>
                        </button>
                        <mat-menu #automationOptions="matMenu">
                          <button mat-menu-item (click)="removeAutomation(automationSetting)" type="button">
                            <mat-icon [svgIcon]="'delete'"></mat-icon>
                            Delete Automation
                          </button>
                          <button mat-menu-item (click)="duplicateAutomation(automationSetting)" type="button">
                            <mat-icon [svgIcon]="'file_copy'"></mat-icon>
                            Duplicate Automation
                          </button>
                        </mat-menu>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="automationSettingsTableColumns; sticky: true"></tr>
                  <tr
                    class="automation-row"
                    mat-row
                    *matRowDef="let automationSetting; columns: automationSettingsTableColumns"
                  ></tr>
                </table>
              </ng-container>
            </ng-container>
          </div>

          <ng-template #noAutomations>
            <div class="no-automations">There are no automations!</div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
